export const queryKeys = {
  getMealData: 'get-meal-data',
  getAllScheduleData: 'get-all-schedule-data',
  getAllMealPortionsData: 'get-all-meal-portions-data',
  getAllPortionSizePrice: 'get-all-portion-size-price',
  getAllCanteens: 'get-all-canteens',
};
